import { Component } from 'react';
import _ from 'lodash';
import styled from 'styled-components';
import { styled as muiStyled } from '@mui/system';
import { Dialog, DialogActions, DialogContent, DialogTitle, FormControl, FormControlLabel, FormLabel, Grid, Radio, RadioGroup } from '@mui/material';

//kendo
import { DropDownList, MultiSelect } from '@progress/kendo-react-dropdowns';

//comps
import Button from '../../global/button';

//services
import TimetableApi from '../../../api/timetable/timetable.api';

// Define styled components
const StyledFormControl = muiStyled(FormControl)`
    min-width: 120px;
    width: 100%;
`;

const StyledRoot = muiStyled('div')`
    display: flex;
    & > * {
        margin: ${(props) => props.theme.spacing(1)};
        width: ${(props) => props.theme.spacing(16)};
        height: ${(props) => props.theme.spacing(16)};
    }
`;

class PrintMultipleReports extends Component {
    _timetablesApi = new TimetableApi();

    constructor(props) {
        super(props);
        this.state = {
            selectedDepartment: {},
            selectedSubject: '',
            sets: [],
            setsSelected: [],

            instructorsBySubject: [],
            instructorsSelected: [],

            autoClose: false,
            isCourseOptionSelected: false,
            dropdownMode: 'department',

            roomsByBuilding: [],
            roomsSelected: [],
        };
    }

    handleDepartmentChange = async (event) => {
        const selectedDepartment = event.target.value;

        const sets = await this._timetablesApi.GetSets(selectedDepartment.departmentID);

        this.setState({ selectedDepartment, sets });
    };

    handlePrintMultiple = () => {
        const { multiplePrintType } = this.props;
        if (multiplePrintType === 'set') {
            const { setsSelected } = this.state;
            const setIDs = setsSelected.map((set) => set.setID);

            this.props.printMultiple(setIDs);
        } else if (multiplePrintType === 'instructor') {
            const { instructorsSelected } = this.state;
            const instructorIDs = instructorsSelected.map((ins) => ins.instructorID);

            this.props.printMultiple(instructorIDs);
        } else if (multiplePrintType === 'room') {
            const { roomsSelected } = this.state;
            const roomIDs = roomsSelected.map((r) => r.roomID);

            this.props.printMultiple(roomIDs);
        }
    };

    handleChange = async (event) => {
        let value = [...event.target.value];
        const { multiplePrintType } = this.props;

        if (multiplePrintType === 'set') {
            this.setState({ setsSelected: value });
        } else if (multiplePrintType === 'instructor') {
            this.setState({ instructorsSelected: value });
        } else if (multiplePrintType === 'room') {
            this.setState({ roomsSelected: value });
        }
    };

    /*
     * - Change mode between "Program" and "Subject"
     * - Reset the selected instructors
     */
    handleDropdownModeChange = (event) => {
        const dropdownMode = event.target.value;
        this.setState({ dropdownMode, instructorsSelected: [] });
    };

    handleSubjectChange = async (event) => {
        const selectedSubject = event.target.value;

        const instructorsBySubject = await this._timetablesApi.GetInstructorsBySubject(selectedSubject);

        this.setState({ instructorsBySubject });
    };

    handleBuildingChange = async (event) => {
        const selectedBuilding = event.target.value;

        const roomsByBuilding = await this._timetablesApi.GetRooms(selectedBuilding);

        this.setState({
            roomsByBuilding,
        });
    };

    handlePrintAll = () => {
        const selectedDepartment = this.state.selectedDepartment;
        this.props.printAll(selectedDepartment.departmentID);
    };

    render() {
        const { open, cancelPrint, departments, instructors, multiplePrintType, subjects, buildings } = this.props;
        const { selectedDepartment, sets, autoClose, instructorsBySubject, dropdownMode, selectedSubject, instructorsSelected, roomsByBuilding } = this.state;

        const filteredInstructors = instructors.filter((ins) => ins.department.departmentID === selectedDepartment.departmentID);

        return (
            <StyledRoot>
                <Dialog open={open} onClose={cancelPrint} fullWidth maxWidth="sm">
                    <DialogTitle>Print Multiple Reports</DialogTitle>
                    <StyledDialogContent>
                        {multiplePrintType === 'instructor' && (
                            <Grid container>
                                <StyledFormControl variant="outlined">
                                    <FormLabel component="legend">Instructors can either be selected by Program (default) or Subject</FormLabel>
                                    <RadioGroup aria-label="position" name="position" value={dropdownMode} onChange={this.handleDropdownModeChange} row>
                                        <FormControlLabel value="department" control={<Radio color="primary" />} label="Program" labelPlacement="start" />
                                        <FormControlLabel value="subject" control={<Radio color="primary" />} label="Subject" labelPlacement="start" />
                                    </RadioGroup>
                                </StyledFormControl>
                            </Grid>
                        )}
                        <Grid container>
                            <Grid item xs={6}>
                                {/* Render Department or Set dropdown */}
                                {(multiplePrintType === 'set' || multiplePrintType === 'instructor') && (
                                    <>
                                        {dropdownMode === 'department' && (
                                            <DropDownList
                                                data={departments}
                                                value={selectedDepartment}
                                                textField={'departmentCode'}
                                                dataItemKey={'departmentID'}
                                                onChange={this.handleDepartmentChange}
                                                label={'Select a Program'}
                                            />
                                        )}

                                        {dropdownMode === 'subject' && <DropDownList data={subjects} onChange={this.handleSubjectChange} label={'Select a Subject'} />}
                                    </>
                                )}
                                {/*  Render Building Dropdown  */}
                                {multiplePrintType === 'room' && <DropDownList data={buildings} textField={'buildingCode'} dataItemKey={'buildingID'} onChange={this.handleBuildingChange} label={'Select a Building'} />}
                            </Grid>
                            <Grid item xs={6}>
                                <StyledFormControl variant="outlined">
                                    {multiplePrintType === 'set' && (
                                        <MultiSelect data={sets} textField={'setCode'} dataItemKey={'setID'} onChange={this.handleChange} label={'Select Multiple Sets'} autoClose={autoClose} />
                                    )}

                                    {multiplePrintType === 'instructor' && (
                                        <MultiSelect
                                            data={dropdownMode === 'subject' ? instructorsBySubject : filteredInstructors}
                                            value={instructorsSelected}
                                            textField={'name'}
                                            dataItemKey={'instructorID'}
                                            onChange={this.handleChange}
                                            label={'Select Multiple Instructors'}
                                            autoClose={autoClose}
                                        />
                                    )}

                                    {/*  Render Room Dropdown  */}
                                    {multiplePrintType === 'room' && (
                                        <MultiSelect data={roomsByBuilding} textField={'roomNumber'} dataItemKey={'roomID'} onChange={this.handleChange} label={'Select Multiple Rooms'} autoClose={autoClose} />
                                    )}
                                </StyledFormControl>
                            </Grid>
                        </Grid>
                    </StyledDialogContent>
                    <StyledDialogActions>
                        <Button onClick={cancelPrint} variant="cancel">
                            Cancel
                        </Button>
                        <Button onClick={this.handlePrintMultiple} variant="save">
                            Print Selected
                        </Button>
                        {/* Only for Departments that have Instructors attached to them */}
                        {dropdownMode === 'department' && !_.isEmpty(selectedDepartment) && Array.isArray(filteredInstructors) && filteredInstructors.length > 0 && (
                            <Button onClick={this.handlePrintAll} variant="save">
                                Print all for {selectedDepartment.departmentCode}
                            </Button>
                        )}
                    </StyledDialogActions>
                </Dialog>
            </StyledRoot>
        );
    }
}

const StyledDialogContent = styled(DialogContent)`
    && {
        label {
            background: #fff;
            padding: 3px;
        }

        legend {
            border: none;
        }
    }
`;

const StyledDialogActions = styled(DialogActions)`
    && {
        padding: 24px;
    }
`;

export default PrintMultipleReports;
